import React, { createContext, useContext } from 'react';
import { Schema } from 'zod';

import {
  TCustomFormContext,
  TCustomFormProvider,
} from '@/shared/components/ui/form/context/form-context.types';

const CustomFormContext = createContext<TCustomFormContext | undefined>(
  undefined,
);

export const useCustomForm = () => {
  const context = useContext(CustomFormContext);
  if (!context) {
    throw new Error('useCustomForm must be used within CustomFormProvider');
  }
  return context;
};

export const CustomFormProvider = ({
  children,
  schema,
  currentSchema,
  setCurrentSchema,
}: TCustomFormProvider) => {
  const updateSchema = (schema: Schema) => {
    setCurrentSchema(schema);
  };

  const resetSchema = () => {
    setCurrentSchema(schema);
  };

  return (
    <CustomFormContext
      value={{
        schema: currentSchema,
        updateSchema,
        resetSchema,
      }}
    >
      {children}
    </CustomFormContext>
  );
};
